<template>
  <v-app style="overflow-y: hidden;overflow-x: hidden;">
    <v-content>
      <customNotification />
      <Loader />
      <router-view />
    </v-content>
  </v-app>
</template>

<script>
import Loader from "./components/Loader";
import customNotification from "./components/Notification";
// import firebase from "firebase/app";
// import "firebase/messaging";
// import "firebase/auth";
// import firebaseConfig from "../firebase-config.json";

export default {
  name: "App",
  components: {
    Loader,
    customNotification,
  },
  async created() {
    this.$firebaseApp
      .auth()
      .signInAnonymously()
      .then((result) => {
        // console.log(result);
      })
      .catch((error) => {
        let errorCode = error.code;
        let errorMessage = error.message;
        console.log(`Error code ${errorCode} => ${errorMessage}`);
      });

    if (this.$firebaseApp.firebase_.messaging.isSupported()) {
      const messaging = await this.$firebaseApp.messaging();
      await messaging.requestPermission();
      const fcmToken = await messaging.getToken();
      localStorage.setItem("fcm_token", fcmToken);
    }
  },
};
</script>
<style>
body {
  background-color: #d2ebd3;
}
.theme--light.v-application {
  background-color: #fafdfb !important;
}
.v-application {
  font-family: "Nunito", sans-serif !important;
}
</style>
